const mediaItems = [
  { title: '《我独自升级》动画PV公开', desc: '猎人协会激战画面首次曝光，粉丝热切期待动画化进程。', img: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20animation%20promotional%20visual%20with%20epic%20battle%20scene%20silhouettes%2C%20dramatic%20lighting%20in%20coral%20and%20cream%20tones%2C%20cinematic%20wide%20composition%2C%20flat%20illustration%20style%20with%20play%20button%20overlay%20feel&width=800&height=500&seq=media-01-2026&orientation=landscape', alt: '我独自升级动画PV' },
  { title: '韩漫改编影视作品大盘点', desc: '从《社内相亲》到《女神降临》，那些被改编成韩剧的人气韩漫。', img: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20to%20drama%20adaptation%20theme%20illustration%20with%20film%20reel%20and%20comic%20pages%20blending%20together%2C%20warm%20coral%20and%20cream%20palette%2C%20cinematic%20atmosphere%2C%20flat%20illustration%20style&width=800&height=500&seq=media-02-2026&orientation=landscape', alt: '韩漫改编影视作品' },
  { title: '2026夏季新番韩漫推荐', desc: '暑期必追！10部不可错过的夏季新连载韩漫免费漫画推荐。', img: 'https://readdy.ai/api/search-image?query=A%20summer%20themed%20Korean%20manhwa%20recommendation%20illustration%20with%20colorful%20comic%20panels%20and%20tropical%20elements%2C%20warm%20coral%20and%20cream%20tones%2C%20lively%20atmosphere%2C%20flat%20illustration%20style&width=800&height=500&seq=media-03-2026&orientation=landscape', alt: '2026夏季新番韩漫推荐' },
  { title: '韩漫阅读趋势报告', desc: '2026上半年热门韩漫免费阅读数据揭秘，奇幻题材成最大赢家。', img: 'https://readdy.ai/api/search-image?query=A%20data%20visualization%20themed%20Korean%20manhwa%20illustration%20with%20charts%20and%20comic%20elements%20combined%2C%20warm%20coral%20and%20cream%20palette%2C%20modern%20analytical%20vibe%2C%20flat%20illustration%20style&width=800&height=500&seq=media-04-2026&orientation=landscape', alt: '韩漫阅读趋势报告' },
  { title: '创作者访谈：人气韩漫作家幕后', desc: '独家对话多位韩漫创作者，揭秘热门韩漫免费漫画的诞生过程。', img: 'https://readdy.ai/api/search-image?query=A%20creative%20studio%20Korean%20manhwa%20theme%20illustration%20with%20artist%20working%20at%20drawing%20tablet%2C%20warm%20coral%20and%20cream%20tones%2C%20inspirational%20atmosphere%2C%20flat%20illustration%20style&width=800&height=500&seq=media-05-2026&orientation=landscape', alt: '创作者访谈' },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          韩漫资讯
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.slice(0, 3).map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4">
          {mediaItems.slice(3).map((item, i) => (
            <div
              key={i + 3}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative w-full sm:w-48 aspect-video sm:aspect-auto overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.alt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-10 h-10 rounded-full bg-background-50/80 flex items-center justify-center">
                      <i className="ri-play-fill text-primary-500 text-base ml-0.5"></i>
                    </div>
                  </div>
                </div>
                <div className="flex-1 p-4">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}